module.exports = "/_next/static/images/37aa562955d3dd7c78fecab1124e5179-man-holding-two-phones@0.5x.jpg.webp";